import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import FeelingProud from "./FeelingProud";

export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.text }}>
                {greeting.title}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: theme.text }}>
                  CPO & Co-Founder at{" "}
                  <a
                    href="https://www.artiso.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: theme.text,
                      textDecoration: "none",
                      borderBottom: `2px solid ${theme.text}`,
                    }}
                  >
                    Artiso AI
                  </a>
                </h2>
              )}
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                {greeting.subTitle}
              </p>
              <SocialMedia theme={theme} />
              <div className="greeting-artiso-div">
                <a
                  href="https://www.artiso.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="greeting-artiso-link"
                >
                  <img
                    src={require("../../assests/images/artiso.svg")}
                    alt="Artiso AI"
                    className="greeting-artiso-logo"
                  />
                  <span style={{ color: theme.text }}>
                    Artiso AI — AI for Fashion Creatives
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <FeelingProud theme={theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
